// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tipsInfo[data-v-2cf0cf1c]{align-items:center;color:#80869a;display:flex;font-size:12px;font-weight:400;line-height:16px}.tipsInfo__ico[data-v-2cf0cf1c]{align-items:center;display:inline-flex;margin-right:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
